/* this file added by Bearer Web Developer  */
import { createContext, useContext } from 'react';
export enum ThemeMode {
    Light = 'light',
    Dark = 'dark',
    // System: 'system'
}
interface ThemeContextType {
    toggleTheme: () => void;
    setThemeMode: (theme_mode: ThemeMode | 'system', force?: boolean) => void;
    theme: ThemeMode;
    systemTheme: boolean
}
export const getSystemTheme = () => (window?.matchMedia("(prefers-color-scheme: dark)")?.matches ? ThemeMode.Dark : ThemeMode.Light);
// export const initialThemeMode: ThemeMode = localStorage.getItem('theme') as ThemeMode ?? getSystemTheme();
export const initialThemeMode: ThemeMode = getSystemTheme(); // in load time, we will always set theme to system theme

// export const initialThemeMode = ThemeMode.Light;
export const ThemeContext = createContext<ThemeContextType>({
    toggleTheme: () => { },
    setThemeMode: () => { },
    theme: initialThemeMode,
    // systemTheme: !localStorage?.getItem('theme')
    systemTheme: true // in load time, we will always set theme to system theme 
});
export const useThemeMode = () => useContext(ThemeContext); 